import { render, staticRenderFns } from "./Cashier.vue?vue&type=template&id=3b6b6008&scoped=true"
import script from "./Cashier.vue?vue&type=script&lang=js"
export * from "./Cashier.vue?vue&type=script&lang=js"
import style0 from "./Cashier.vue?vue&type=style&index=0&id=3b6b6008&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6b6008",
  null
  
)

export default component.exports